var _linearGradient, _style, _path, _g, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBgLetter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1921 984"
  }, props), /*#__PURE__*/React.createElement("defs", null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg_letter_svg__gradient",
    x1: 1166.2,
    y1: 1007.49,
    x2: 416.59,
    y2: 533.96,
    gradientTransform: "matrix(1 0 0 -1 0 984)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#afc5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#afc5ff",
    stopOpacity: 0
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "@keyframes dash-ani{0%{stroke-dashoffset:800;opacity:.2}to{stroke-dashoffset:0;opacity:1}}@keyframes move-ani-01{0%{transform:translateY(0)}to{transform:translateY(-40px)}}@keyframes move-ani-02{0%{transform:translateY(0)}to{transform:translateY(50px)}}.bg_letter_svg__cls-3,.bg_letter_svg__cls-8{fill:none}.bg_letter_svg__cls-8{opacity:.5}.bg_letter_svg__cls-3,.bg_letter_svg__cls-8{stroke:#afc5ff;stroke-miterlimit:10}.bg_letter_svg__cls-8{stroke-dasharray:4 4}.bg_letter_svg__move-01,.bg_letter_svg__move-02{animation-name:move-ani-01;animation-duration:1s;animation-iteration-count:infinite;animation-direction:alternate;animation-timing-function:cubic-bezier(.55,.45,.45,.5)}.bg_letter_svg__move-02{animation-name:move-ani-02;animation-duration:1.5s}")), /*#__PURE__*/React.createElement("mask", {
    id: "bg_letter_svg__mask-path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1267.35-59L515.57 359.13",
    style: {
      animationName: "dash-ani",
      animationDuration: "1s",
      animationTimingFunction: "cubic-bezier(.165,.84,.44,1)"
    },
    stroke: "var(--bs-white)",
    strokeWidth: 10,
    strokeDasharray: 800
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    mask: "url(#bg_letter_svg__mask-path)",
    d: "M1267.35-59L515.57 359.13",
    strokeDasharray: "6 6",
    stroke: "url(#bg_letter_svg__gradient)",
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "bg_letter_svg__move-02",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    className: "bg_letter_svg__cls-3",
    d: "M1076.57 128v-2h2"
  }), /*#__PURE__*/React.createElement("path", {
    strokeDasharray: "3.43 3.43",
    stroke: "#afc5ff",
    strokeMiterlimit: 10,
    fill: "none",
    d: "M1082 126h18.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bg_letter_svg__cls-3",
    d: "M1102.56 126h2v2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1104.56 132v65.67a33.56 33.56 0 007.27 23.46 26.23 26.23 0 0020.19 7.6 26.75 26.75 0 0020.25-7.6 32 32 0 007.21-22.81V130",
    strokeDasharray: "3.97 3.97",
    stroke: "#afc5ff",
    strokeMiterlimit: 10,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bg_letter_svg__cls-3",
    d: "M1159.48 128v-2h2"
  }), /*#__PURE__*/React.createElement("path", {
    strokeDasharray: "3.44 3.44",
    stroke: "#afc5ff",
    strokeMiterlimit: 10,
    fill: "none",
    d: "M1164.91 126h18.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bg_letter_svg__cls-3",
    d: "M1185.53 126h2v2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1187.53 132v65.48a73 73 0 01-4 25.17 47.25 47.25 0 01-11.07 17.82 46 46 0 01-17.7 10.69 70.42 70.42 0 01-23.07 3.8 55.8 55.8 0 01-40.37-14.42c-9.9-9.37-14.75-23.46-14.75-42.14V130",
    strokeDasharray: "3.96 3.96",
    stroke: "#afc5ff",
    strokeMiterlimit: 10,
    fill: "none"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "bg_letter_svg__move-01 bg_letter_svg__cls-8",
    d: "M1756.78 294.36a39.68 39.68 0 01-11 13.73 48.49 48.49 0 01-16 8.25 70.38 70.38 0 01-19.72 2.78h-21v37.33h-27.53V232h51.18a62.68 62.68 0 0120.11 3.09 44 44 0 0115 8.71 38 38 0 019.48 13.67 45.19 45.19 0 013.35 17.53v.39a44.57 44.57 0 01-3.93 19.34zm-24.11-18.77a16.69 16.69 0 00-6-14 25.76 25.76 0 00-16.31-4.77H1689v38h21.85a22.43 22.43 0 0016.25-5.42 17.39 17.39 0 004.32-6.06 18 18 0 001.41-7.35z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "bg_letter_svg__move-02 bg_letter_svg__cls-8",
    d: "M250.58 440.69a62.51 62.51 0 01-11.67 7.19 60.17 60.17 0 01-13.78 4.41 81 81 0 01-17 1.59 65.92 65.92 0 01-26.37-5.15 63.21 63.21 0 01-20.83-13.84A62.26 62.26 0 01147.2 414a67 67 0 01-4.61-26 65.89 65.89 0 0118.66-46.15 63.13 63.13 0 0121-14.57 67.75 67.75 0 0127-5.21 85.42 85.42 0 0116.35 1.45 68.93 68.93 0 0113.18 4 57 57 0 0111.21 6.2 78.05 78.05 0 019.76 8.11l-17.93 20.44a64.59 64.59 0 00-15.3-10.55 39.1 39.1 0 00-17.27-3.83 35.22 35.22 0 00-14.9 3.1 34.44 34.44 0 00-11.8 8.57 39.39 39.39 0 00-7.45 12.66 43.12 43.12 0 00-2.77 15.36v.4a44.27 44.27 0 002.77 15.49 40.33 40.33 0 007.58 12.73 34.71 34.71 0 0012.2 8.76 35.06 35.06 0 0014.7 3 40.38 40.38 0 0018.65-3.96 73 73 0 0015.1-11l17.53 18a93.24 93.24 0 01-10.28 9.69z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "bg_letter_svg__move-02 bg_letter_svg__cls-8",
    style: {
      animationDuration: "3s"
    },
    d: "M1432.46 646.23v-50.3h-51.15v50.3h-27.74V521h27.74v49.72h51.08V521h27.68v125.23z"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "bg_letter_svg__move-01 bg_letter_svg__cls-8",
    d: "M104 883.23l-11.43-27.68H40.1l-11.38 27.68H.92L54.09 759h25.19l53.24 124.38zm-37.63-91.72l-16.49 40.07h33z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "bg_letter_svg__move-02 bg_letter_svg__cls-8",
    d: "M946.81 903V777.54h27.79V903z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "bg_letter_svg__move-01 bg_letter_svg__cls-8",
    d: "M1897 982.3l-61.2-79.87v79.87h-27.19V856.64h25.63l58.92 77.4v-77.4h27.45V982.3z"
  })));
}

export default SvgBgLetter;